export default "__VITE_ASSET__CGDxDcJf__"